import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ConfirmPaymentSettings } from '../settings/confirm_payment.settings';
import { HttpCssClient } from '../shared/http-request.interceptor';

@Injectable()
export class ConfirmPaymentService{
    constructor(private http:HttpCssClient){}
    getPaymentResume():Observable<Object>{
        let url = ConfirmPaymentSettings.GET_RESUME;
        return this.http.get(url,null,false,false, true).pipe(map(response => {
            let body;
            let token = response.headers.get("authorization");
            if (response.status === 200) {
                body = response.body;
            }
            return {response: body, token: token};
        }));
    }

    getVoucher(token){
        let url = ConfirmPaymentSettings.GET_VOUCHER;
        url = url.replace(':token',token);
        return url;
    }

}